import { CombinedPurchaseHistory } from '@tock/shared/utils/patronUtils';
import { CurrencyContext, LocaleContext, safeToNumber } from '@tock/coretypes';
import { DisplayDate, DisplayDateTime } from '@tock/time';
import { DisplayMoney } from '@tock/money';
import { Typography } from 'omakase';
import BaseComponent from '@tock/shared/components/BaseComponent';

interface Props {
  item: CombinedPurchaseHistory;
}

export default class TransactionHistoryItem extends BaseComponent<Props> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getAction(item: any) {
    if (item.transferred) {
      return item.firstTransferredTo
        ? 'Transferred to: ' + item.firstTransferredTo.email
        : 'Transferred';
    } else if (item.isTransferredFrom && !item.cancelledOrRefunded) {
      return 'Purchase. Transferred from: ' + item.transferredFromEmail;
    } else if (item.cancelledOrRefunded) {
      return 'Purchase. (Canceled)';
    } else {
      return 'Purchase';
    }
  }

  render() {
    const { item } = this.props;

    if (!item.latestPurchase) {
      return null;
    }

    return (
      <header className="TransactionHistory-row TransactionHistory-row--body">
        <div className="TransactionHistory-cell TransactionHistory-cell--body TransactionHistory-cell--date">
          <div className="TransactionHistory-cellLabel">
            <Typography color="inherit" component="span" variant="body02">
              Date
            </Typography>
          </div>

          <div className="TransactionHistory-cellText">
            <Typography color="inherit" component="span" variant="body02">
              <DisplayDate
                dateValue={
                  new Date(safeToNumber(item.purchaseTimestamp)).toISOString().split('T')[0]
                }
                displayMonthAs="numeric"
                showWeekday={false}
              />
            </Typography>
          </div>
        </div>

        <div className="TransactionHistory-cell TransactionHistory-cell--body TransactionHistory-cell--details">
          <div className="TransactionHistory-cellLabel">
            <Typography color="inherit" component="span" variant="body02">
              Details
            </Typography>
          </div>

          <div className="TransactionHistory-cellText">
            <Typography color="inherit" component="span" variant="body02">
              {`${this.getAction(item)} - ${item.businessName} - ${item.ticketTypeName} on `}
              <DisplayDateTime dateTimeValue={item.ticketDateTime} showWeekday={true} />
            </Typography>
          </div>
        </div>

        <div className="TransactionHistory-cell TransactionHistory-cell--body TransactionHistory-cell--amount">
          <div className="TransactionHistory-cellLabel">
            <Typography color="inherit" component="span" variant="body02">
              Amount
            </Typography>
          </div>

          <div className="TransactionHistory-cellText">
            <Typography color="inherit" component="span" variant="body02">
              <CurrencyContext.Provider value={item.currencyCode}>
                <LocaleContext.Provider value={item.locale}>
                  <DisplayMoney amount={item.amountPaidCents} />
                </LocaleContext.Provider>
              </CurrencyContext.Provider>
            </Typography>
          </div>
        </div>
      </header>
    );
  }
}
